import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { useInView } from 'react-intersection-observer';

import styles from './styles.pcss';
import { definedIcons, ICON_DEFAULT } from './constants';
import * as allIcons from './assets';

const cx = classNames.bind(styles);
const fallbackIcon = definedIcons[ICON_DEFAULT];

type CollectionMenuItemType = {
  iconName: string;
  text: string;
  href: string;
  id?: string;
  isActive: boolean;
  isTablet: boolean;
  isMobile: boolean;
  className?: string;
  onClick: () => void;
  onViewed: () => void;
};

export const CollectionMenuItem = ({
  iconName,
  text,
  href,
  id,
  isActive,
  isTablet,
  isMobile,
  className,
  onClick,
  onViewed,
}: CollectionMenuItemType) => {
  const iconRef = useRef(null);
  const Icon = allIcons[definedIcons[iconName]] || fallbackIcon;
  const getClasses = () => {
    const classes = ['component'];
    if (isMobile) {
      classes.push('mobile');
    }
    if (isTablet) {
      classes.push('tablet');
    }
    if (isActive) {
      classes.push('active');
    }
    if (className) {
      classes.push(className);
    }
    return classes;
  };

  const [deviceRef] = useInView({
    triggerOnce: true,
    threshold: 1,
    onChange: (inView) => {
      if (inView) {
        onViewed();
      }
    },
  });

  useEffect(() => {
    setTimeout(function () {
      if (isActive && iconRef && iconRef.current) {
        iconRef.current.scrollIntoView({ block: 'end', inline: 'center' });
      }
    }, 100);
  }, [isActive, id]);

  return (
    <div ref={iconRef}>
      <a href={href} id={id} className={cx(getClasses())} onClick={onClick} ref={deviceRef}>
        <span className={cx('icon')}>
          <Icon />
        </span>
        <Text size={isActive ? 'size5-m' : 'size5-r-s'} className={cx('title')}>
          {text}
        </Text>
      </a>
    </div>
  );
};
